/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import * as S from './styles';
import { useTheme } from '../../../../providers/theme';
import { Modal } from 'react-bootstrap';

const is = require('is_js');

export interface ILoaderProps {}

export const LoaderModal = ({}: ILoaderProps) => {
  const theme = useTheme();
  const [visible, setVisible] = useState(true);

  return (
    <Modal
      show={visible}
      onHide={() => setVisible(false)}
      backdrop={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <S.ModalBodyContainer>
        <S.SpinnerContainer animation="border" role="status" />
        {'Request in Progress'}
      </S.ModalBodyContainer>
    </Modal>
  );
};

LoaderModal.defaultProps = {};
